import React from 'react';
import MediaQuery from 'react-responsive/src/Component';
import HistoryMomentsMobile from 'components/organisms/historyMomentsMobile';
import HistoryMoments from 'components/organisms/historyMoments';

const HistoryMomentsSection = props => {
  if (!props.data) {
    return null;
  }
  return (
    <div id={'history-moments'}>
      <MediaQuery maxDeviceWidth={575.6}>
        <HistoryMomentsMobile data={props} />
      </MediaQuery>
      <MediaQuery minDeviceWidth={576}>
        <HistoryMoments data={props} />
      </MediaQuery>
    </div>
  );
};

export default HistoryMomentsSection;
